import { PRESUPUESTO_AUTOMATIC_SAVE, PRESUPUESTO_ULTIMO_EDITADO } from '../../../features/presupuestador/lib/constants';

export const getPresupuestoUltimoEditado = (userId) => {
  const key = `${PRESUPUESTO_ULTIMO_EDITADO}_${userId}`;
  return JSON.parse(localStorage.getItem(key));
}

export const setPresupuestoUltimoEditado = (userId, presupuestador) => {
  const key = `${PRESUPUESTO_ULTIMO_EDITADO}_${userId}`;
  localStorage.setItem(key, JSON.stringify(presupuestador));
}

export const removePresupuestoUltimoEditado = (userId) => {
  const key = `${PRESUPUESTO_ULTIMO_EDITADO}_${userId}`;
  localStorage.removeItem(key);
}

export const getPresupuestoAutomaticSave = (userId) => {
  const key = `${PRESUPUESTO_AUTOMATIC_SAVE}_${userId}`;
  return localStorage.getItem(key);
}

export const setPresupuestoAutomaticSave = (userId, state) => {
  const key = `${PRESUPUESTO_AUTOMATIC_SAVE}_${userId}`;
  localStorage.setItem(key, state);
}

export const removePresupuestoAutomaticSave = (userId) => {
  const key = `${PRESUPUESTO_AUTOMATIC_SAVE}_${userId}`;
  localStorage.removeItem(key);
}